import React, {useEffect} from "react";
import { Container, Grid, Typography, Box } from "@mui/material";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import splashImg from "../assets/images/1000107301.jpg";
import ScrollReveal from "scrollreveal";

const Discourses = () => {

  useEffect(() => {
    ScrollReveal().reveal(".reveal-left", {
      duration: 2000, // Animation duration (in ms)
      distance: "100px", // Distance the element moves
      origin: "left", // Animation starts from the left
      easing: "ease-in-out", // Easing function
      reset: true, // Reset the animation when scrolling back
    });

    ScrollReveal().reveal(".reveal", {
      duration: 2000, // Animation duration (in ms)
      distance: "100px", // Distance the element moves
      origin: "bottom", // Animation starts from the left
      easing: "ease-in-out", // Easing function
      reset: true, // Reset the animation when scrolling back
    });
  }, []);

  return (
    <Container
      maxWidth="lg"
      sx={{ minHeight: "100vh", display: "flex", alignItems: "center" }}
    >
      <Grid container spacing={4} alignItems="center">
        {/* Image Section */}
        <Grid item xs={12} md={6} className="reveal-left">
          <Box
            component="img"
            src={splashImg}
            alt="Swift Móvil App"
            sx={{
              width: "100%",
              maxWidth: "300px",
              margin: "auto",
              display: "block",
              borderRadius: "16px", // Add border radius
              transition: "transform 0.3s ease-in-out", // Transition for scale
              "&:hover": {
                boxShadow: "0 4px 20px #8C3A00", // Dark orange shadow
                transform: "scale(1.01)", // Scale up on hover
              },
            }}
          />
        </Grid>

        {/* Text Section */}
        <Grid item xs={12} md={6} className="reveal">
          <Typography variant="h4" gutterBottom>
            Vedānta Talks by HH Swami Paramarthananda Saraswathi
          </Typography>
          <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
            {[
              "Search and select discourses on Vedānta and chantings.",
              "Purchase your chosen discourses easily.",
              "Choose from a wide range of categories.",
              "Make your wish list for easy access.",
              "Access your purchased discourses from your account.",
            ].map((text, index) => (
              <li key={index}>
                <Typography variant="body1" display="flex" alignItems="center">
                  <IoMdCheckmarkCircleOutline
                    style={{
                      fontSize: "30px",
                      color: "orange",
                      marginRight: "16px",
                    }}
                  />
                  {text}
                </Typography>
              </li>
            ))}
          </ul>

          {/* App Store Buttons */}
          <Grid container spacing={2}>
            <Grid item>
              <a
                href="https://play.google.com/store/apps/details?id=com.sastra.im037.sastraprakasika&pcampaignid=web_share"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://sastraprakasika.com/wp-content/uploads/2018/07/google-play.png"
                  width="100%"
                  alt="Google Play"
                />
              </a>
            </Grid>
            <Grid item>
              <a
                href="https://apps.apple.com/in/app/sastraprakasika/id1480843207"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://sastraprakasika.com/wp-content/uploads/2018/07/apple-store.png"
                  width="100%"
                  alt="Apple Store"
                />
              </a>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Discourses;
